import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { TasksProgression } from "./tasksProgression";
import { Stats } from "./stats";
import { Milestones } from "./milestones";
import styles from "./styles.scss";

function Monitoring({ project, synthesis }: Props) {
  const { t } = useTranslation();
  const isProjectPlanned =
    !!project.rootList.startDate &&
    !!project.rootList.endDate &&
    (synthesis.tasksNbr > 0 || synthesis.milestonesNbr > 0);

  return isProjectPlanned ? (
    <div className={styles.monitoring}>
      <div className={styles.progressions}>
        {synthesis.proportionOfAccomplishedWork > 0 && (
          <div
            className={styles.done}
            style={{ width: `${synthesis.proportionOfAccomplishedWork}%` }}
          >
            <TasksProgression
              title={t("projectPage.synthesisPage.monitoring.doneTitle")}
              color="#98d292"
              hours={synthesis.workedHours}
              percentage={synthesis.proportionOfAccomplishedWork}
            />
          </div>
        )}
        {synthesis.proportionOfDelayedWork > 0 && (
          <div
            className={styles.delayed}
            style={{ width: `${synthesis.proportionOfDelayedWork}%` }}
          >
            <TasksProgression
              title={t("projectPage.synthesisPage.monitoring.overDueTitle")}
              color="#DD3D3D"
              hours={synthesis.delayedWorkHours}
              percentage={synthesis.proportionOfDelayedWork}
            />
          </div>
        )}
        {synthesis.proportionOfOpenedWork > 0 && (
          <div
            className={styles.delayed}
            style={{ width: `${synthesis.proportionOfOpenedWork}%` }}
          >
            <TasksProgression
              title={t("projectPage.synthesisPage.monitoring.openedTitle")}
              color="#9b9b9b"
              hours={synthesis.openedWorkHours}
              percentage={synthesis.proportionOfOpenedWork}
            />
          </div>
        )}
      </div>
      <div>
        <Stats synthesis={synthesis} />
      </div>
      <div className={styles.milestones}>
        <Milestones
          project={project}
          milestones={[
            ...synthesis.delayedMilestones,
            ...synthesis.upComingMilestones,
            ...synthesis.finishedMilestones,
          ]}
        />
      </div>
    </div>
  ) : (
    <p className={styles.fallback}>
      {t("projectPage.synthesisPage.monitoring.fallBack")}
    </p>
  );
}

export { Monitoring };
